
export default {
  routeExtras: {
    extras: 'Routen Extras',
    extraInfo: 'Zusatzinformationen',
    value: 'Wert',
    clickToHighlightOnMap: 'Klicken um auf der Karte anzuzeigen',
    showAllOnMap: 'Alle auf Karte zeigen'
  }
}
